import { useNavigate } from 'react-router-dom';
import styled from "styled-components";
import ThemeDefault from "../theme/ThemeDefault";

const GoBackDiv = styled.div`
  /* padding: 0.8rem 2.4rem; */
  background: ${ThemeDefault.black};
  margin-bottom: 1.6rem;
  color: ${ThemeDefault.primary};
  & .inner {
    cursor: pointer;
    /* padding: 0 2.4rem; */
  }
`

export default function GoBack() {
  const navigate = useNavigate();

  return (
    <GoBackDiv className="text--left">
      <div className="inner text--left" onClick={() => navigate(-1)}>
        &laquo; Back
      </div>
    </GoBackDiv>  
  )
}
